export class Constant {
  // static apiAddressMail = 'https://telemeds.herokuapp.com/';
  static apiAddressMail = 'https://testbepharmacy.ranecs.com/';
  static apiAddress = 'https://adminpanel.ranecs.com/';
  static apiAddressHttp = 'https://adminpanel.ranecs.com';
}
